import Vue from "vue";
import { Provider } from "js/crossword/types";
import { canRatePuzzle } from "js/crossword/ratingStore";
import PuzzleRating from "./PuzzleRating";
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

import commonStyle from "../css/common.module.css";
declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    puzzleId: String,
  },
  data() {
    return {
      ratingPossible: canRatePuzzle(this.puzzleId),
      ratingOpened: false,
    };
  },
  methods: {
    closeRating() {
      this.ratingPossible = false;
      this.ratingOpened = false;
    },
    close(showMistakes: boolean) {
      sdkHandler.trigger('interstitialAd', { callback: function() {
        this.$emit("close");
        if (showMistakes) this.$emit("showMistakes");
      }}, this)
    },
  },
  render() {
    return (
      <PopupContainer customClasses={["popup--notComplete"]}>
        { !this.ratingOpened
          ? <div>
            <div class="pauseMessageContainer">
              <img class="headerIcon" src="images/Not_Complete_Icon.svg" style="height: 3em" />
              <div style="margin-left: 1.5em;">
                <div style="fontSize: 1.5; font-weight: bold;">
                  {this.localization.get("You're nearly there")}
                </div>
                <div class={commonStyle.lineBreakEnabled}>
                  {this.localization.get(
                    "Please check the puzzle again,\nsome words still need correcting",
                  )}
                </div>
              </div>
            </div>

            <PopupButtons buttons={[{
              label: this.localization.get("Resume"),
              onClick: () => this.close(false),
            }, {
              label: this.localization.get("Show mistakes"),
              onClick: () => this.close(true),
            }]} />
          </div>
          : null
        }

        { this.ratingPossible
          ? <PuzzleRating
            puzzleId={this.puzzleId}
            onOpenRating={() => this.ratingOpened = true}
            onCloseRating={() => this.ratingOpened = false}
            onClosePopup={this.closeRating}
          />
          : null}
      </PopupContainer>
    );
  },
});
